<template>
  <div class="week-days">
    <div v-for="(weekDay, index) in weekDays" :key="index" class="weekday no-translate" :style="styles">
      {{ weekDay.substring(0,1) }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'WeekDays',
  props: {
    weekDays: { type: Array, default: () => ([]), required: true },
    fontSize: { type: String, default: '15px' },
  },
  computed: {
    styles() {
      return {
        fontSize: parseInt(this.fontSize) > 20 ? '20px' : this.fontSize,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/datepicker.scss";
.week-days {
  width: 100%;
  height: 41px;
  text-transform: uppercase;
  color: $darkBlack;
  font-weight: 400;
  text-align: center;
  margin:0 auto;
  display: grid;
  grid-template-columns: repeat(7, minmax(10px, 1fr));
}

.weekday{
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  font-size: 15px;
  color: $darkBlack;
  fill: $darkBlack;

  @include dp-mobile-down-sm(){
    font-size: 12px;
  }
}

</style>
